import { createStyles } from '@mantine/core';
import editListBanner from '../../../assets/images/editlistBanner.png';
import {body_min_height} from "../../../utils/const.js"
export const useStyles = createStyles((theme) => ({
  wrapperContainer: {
    background: 'rgb(224,244,245,0.5)',
    paddingBottom: 70,
    paddingTop: 40,
    backgroundImage: `url(${editListBanner})`,
    backgroundSize: '80% 85%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right bottom',
    paddingBottom: 100,
    paddingTop: 50,
    [theme.fn.largerThan(786)]: {
        minHeight:`${body_min_height.desktop} !important`
     }
  },

  wrapper: {
    width: '80%',
    margin: 'auto',
    background: 'white',
    padding: 40,
    borderRadius: 20,
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 30,
    boxShadow: '0px 20px 35px rgba(29, 94, 109, 0.03)',
    [theme.fn.smallerThan(1400)]: {
      width: '90%',
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%',
      overflowX: 'scroll',
    },
    'input::placeholder': {
      color: '#616161 !important',
      opacity: 0.5,
    },
    'textarea::placeholder': {
      color: '#616161 !important',
      opacity: 0.5,
}
  },
  editFormAndChangeStatus: {
    display: 'flex',
    columnGap: 70,
    justifyContent: 'space-between',
    [theme.fn.smallerThan(1050)]: {
      columnGap: 30,
    },
    [theme.fn.smallerThan(850)]: {
      flexDirection: 'column',
      rowGap: 20,
    },
  },
  title: {
    fontFamily: `Medium , ${theme.fontFamily}`,
    fontSize: 21,
    color: theme.colors.secondary[0],
    width: '80%',
    margin: 'auto',
    [theme.fn.smallerThan(850)]: {
      width: '95%',
      textAlign: 'center',
      fontSize: 25,
    },
    [theme.fn.smallerThan(1400)]: {
      width: '90%',
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%',
    },
  },
  modalTitle: {
    fontFamily: `Medium , ${theme.fontFamily}`,
    fontSize: 22,
    fontWeight: 500,
    color: theme.colors.secondary[0],
    [theme.fn.smallerThan(850)]: {
      width: '200px',
      height:105,
      lineHeight:"34.5px"
    },
  },
  addFormContainer: {
    width: '50%',
    [theme.fn.smallerThan(650)]: {
      width: '100%',
    },
  },
  inputFields: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 20,
    [theme.fn.smallerThan(650)]: {
      flexDirection: 'column',
    },
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    width: '100%',
    marginTop: 10,
    position: 'relative',
    [theme.fn.smallerThan(650)]: {
      width: '100%',
    },
  },
  inputWrapperRadio: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    width: '100%',
    [theme.fn.smallerThan(650)]: {
      width: '100%',
    },
  },
  radioButtonInputWrapper: {
    display: 'flex',
    rowGap: 10,
    [theme.fn.smallerThan(650)]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  radioOptionWrapper: {
    display: 'flex',
    fontWeight: 500,
    fontFamily: `Medium, ${theme.fontFamily}`,
    label: {
      fontFamily: `Medium, ${theme.fontFamily}`,
      color: theme.colors.text[1],
      fontWeight: 500,
      fontSize: 14,
    },
  },
  addressInput: {
    minWidth: '100%',
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10,
    width: '100%',
    color: theme.colors.primary[0],
    cursor: 'pointer',
    textDecorationLine: 'underline',
    fontWeight: 500,
    fontFamily: `Medium , ${theme.fontFamily}`,
    [theme.fn.smallerThan(650)]: {
      width: '100%',
    },
    a: {
      fontFamily: `Medium , ${theme.fontFamily}`,
      color: theme.colors.primary[0],
      [theme.fn.smallerThan(650)]: {
        fontSize: 16,
      },
    },
  },
  rightArrow: {
    color: theme.colors.primary[0],
  },
  label: {
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 14,
    opacity: 0.5,
  },

  radioLabel: {
    fontFamily: `Regular, ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 14,
    opacity: 0.5,
    marginRight: 20,
    fontWeight: 500,
  },

  radio: {
    marginRight: 20,
    fontWeight: 500,
    color: theme.colors.text[1],
    fontSize: 20,
    marginRight: 20,
  },

  textInput: {
    width: '100%',
    input: {
      padding: 23,
      borderRadius: 13,
      border: '2px solid white',
      outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      borderColor: theme.colors.primary[0],
      background: theme.colors.tertiary[0],
      boxShadow: '0px 15px 25px 0px #00D89B26',
      color: theme.colors.text[1],
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0],
        boxShadow: '0px 15px 25px 0px #00D89B26',
      },
      '&:disabled': {
        fontFamily: `Medium , ${theme.fontFamily}`,
        color: `${theme.colors.text[1]}`,
        fontWeight: 500,
        opacity : 1,
        borderColor: theme.colors.tertiary[0],
      }
    },
  },

  emailTextInput: {
    width: '100%',
    input: {
      padding: '23px 60px 23px 23px',
      marginRight: 0,
      border:"solid 2px red",
      borderRadius: 13,
      border: '2px solid white',
      outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      color: theme.colors.text[1],
      borderColor: theme.colors.primary[0],
      background: theme.colors.tertiary[0],
      boxShadow: '0px 15px 25px 0px #00D89B26',
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0],
        boxShadow: '0px 15px 25px 0px #00D89B26',

      },
      '&:disabled': {
        fontFamily: `Medium , ${theme.fontFamily}`,
        color: `${theme.colors.text[1]}`,
        fontWeight: 500,
        opacity : 1,
        borderColor: theme.colors.tertiary[0],
      }
    },
  },

  textInputPrice: {
    width: '100%',
    input: {
      padding: 23,
      borderRadius: 13,
      border: '2px solid white',
      outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      paddingLeft: 30,
      color: theme.colors.text[1],
      borderColor: theme.colors.primary[0],
      background: theme.colors.tertiary[0],
      boxShadow: '0px 15px 25px 0px #00D89B26',
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0],
        background: theme.colors.tertiary[0],
        boxShadow: '0px 15px 25px 0px #00D89B26',
      },
    },
  },
  textInputNumber: {
    width: '100%',
    input: {
      padding: 23,
      borderRadius: 13,
      border: '2px solid white',
      // outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      paddingLeft: 30,
      color: theme.colors.text[1],
      borderColor: theme.colors.primary[0],
      background: theme.colors.tertiary[0],
      boxShadow: '0px 15px 25px 0px #00D89B26',
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0],
        background: theme.colors.tertiary[0],
        boxShadow: '0px 15px 25px 0px #00D89B26',
      },
    },
  },

  active: {
    background: theme.colors.background[4],
    color: '#64B216',
    [theme.fn.smallerThan(650)]: {
      fontSize: 15,
    },
  },

  textAreaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 6,
    width: '100%',
    height: '100%',
    ':nth-child(3)': {
      label: {
        opacity: 1,
      },
    },
  },

  formDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  actionBtns: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    columnGap: 30,
    [theme.fn.smallerThan(850)]: {
      width: '100%',
      columnGap: 30,
      display: 'flex',
      flexDirection: 'column-reverse',
      justifyContent: 'space-between',
    },
  },
  cancel: {
    fontFamily: `Bold , ${theme.fontFamily}`,
    fontSize: 13,
    color: theme.colors.secondary[0],
    textDecoration: 'none',
    ':hover': {
      cursor: 'pointer',
    },
    [theme.fn.smallerThan(650)]: {
      marginTop: 20,
    },
  },
  btn: {
    width: 218,
    fontSize: 12,
    letterSpacing: 0.15,
    fontFamily: `Regular , ${theme.fontFamily}`,
    [theme.fn.smallerThan(650)]: {
      width: '90%',
      marginTop: 20,
    },
  },
  addBtn: {
    width: 130,
    fontSize: 12,
    letterSpacing: 0.15,
    fontFamily: `Regular , ${theme.fontFamily}`,
    [theme.fn.smallerThan(650)]: {
      width: '90%',
      marginTop: 10,
    },
  },
  textarea: {
    textarea: {
      width: '100%',
      height: 430,
      border: '2px solid white',
      outline: 'none',
      borderRadius: 16,
      backgroundColor: '#F7F9FA',
      fontFamily: `Regular , ${theme.fontFamily}`,

      fontSize: 13,
      transition: '.5s',
      padding: 10,
      color: theme.colors.secondary[0],
      borderColor: theme.colors.primary[0],
      boxShadow: `0 0 5px ${theme.colors.primary[0]}`,
      '&:focus': {
        borderColor: theme.colors.primary[0],
        boxShadow: `0 0 5px ${theme.colors.primary[0]}`,
      },
    },
    '.mantine-Textarea-error': {
      fontFamily: `Regular , ${theme.fontFamily}`,
      fontSize: '16px !important',
    },
  },

  userActions: {
    color: theme.colors.text[1],
    textAlign: 'center',
    width: '70%',
    marginTop: 20,
    fontSize: 14,
    fontFamily: `Regular, ${theme.fontFamily}`,
    color: theme.colors.text[1],
    a: {
      fontFamily: `Medium, ${theme.fontFamily}`,
    },
    [theme.fn.smallerThan(850)]: {
      width: '100%',
      fontSize: 16,
    },
  },
  disabledBtnLarge: {
    color: theme.colors.disabledBtn[0],
    width: 218,
    pointerEvents: 'none',
  },
  disabledBtnSmall: {
    color: theme.colors.disabledBtn[0],
    width: 150,
    pointerEvents: 'none',
  },
  addLandlordText: {
    fontWeight: 500,
    fontSize: 16,
    color: theme.colors.primary[0],
    cursor: 'pointer',
    paddingRight: 20,
    fontFamily: `Medium , ${theme.fontFamily}`,
  },
  emailText: {
    fontWeight: 500,
    fontSize: 16,
    color: theme.colors.text[1],
  },
  popupList: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #D9E2E4',
    marginTop:15,
    height:40
  },
  dollarIcon: { color: theme.colors.secondary[0], strokeWidth: '1' },
  cancelIconModal: {
    cursor: 'pointer',
    zIndex: 1000,
    background: 'white',
    borderRadius: 50,
    top: 55,
    position: 'absolute',
    right: 53,
    ':hover': {
      cursor: 'pointer',
    },
    [theme.fn.smallerThan(850)]: {
      right: 35,
      width:20,
      height:20,
      top:45
    },
  },
  emailError: {
    fontFamily: `Regular , ${theme.fontFamily}`,
    fontSize: '16px !important',
    color: theme.colors.error[0],
  },
  content:{
    padding: '35px',
    display: 'flex',
    flexDirection: 'column',
    height: 663,
    width: 774,
    borderRadius: "24px",
    overflowY: 'auto', 
    maxHeight:'80vh',
    '.mantine-Modal-header':{
      position:"inherit"
    },
    [theme.fn.smallerThan(850)]: {
      padding: 20,

    },
  }
}));
